import {Grid, Text} from '@primer/react-brand'

import IdeList from './IdeList'

export default function SmallIdeSection() {
  return (
    <Grid>
      <Grid.Column span={12}>
        <Text as="p" size="200" variant="muted" weight="medium" align="center" className="mb-5">
          GitHub Copilot is available on your favorite platforms:
        </Text>

        <IdeList type="small" location="pricing-cards" />
      </Grid.Column>
    </Grid>
  )
}

try{ SmallIdeSection.displayName ||= 'SmallIdeSection' } catch {}